import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import  redirectToCVActivation  from '../../../../../utils/MDPUtil';

const InfoWA = (props) => {
  props.googleAnalytics({'event':'vpv-privado','sitesection':'vpv-privado','page':'/tef/dap/sinCuentaVista'});
    return (
      <div className="dap_info-socio">
        <h4>
          <FontAwesomeIcon icon={faInfoCircle} />
          Estimado socio:
        </h4>
        <p>
          Para realizar la contratación de un Depósito a Plazo en línea,{' '}
          <b>necesitas una Cuenta Vista Activa</b>.
        </p>
        <p>
          <Button
            className="dap_btn-primary"
            type="submit"
            onClick={() => {
              redirectToCVActivation();
              props.googleAnalytics({'event':'eve','eve-acc':'/tef/dap','eve-cat':'Click','eve-lab':'Quiero mi Cuenta Vista'});
            }}
          >
            Quiero mi cuenta vista
          </Button>
        </p>
      </div>
    );
}
 
export default InfoWA;